(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pawprint-product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pawprint-product-tabs')) {
    customElements.define('pawprint-product-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = [...this.querySelectorAll('.pp-product-tabs__tab')];
        this.panels = [...this.querySelectorAll('.pp-product-tabs__panel')];
        const nav = this.querySelector('.pp-product-tabs__nav');
        nav.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          });
        });
        this.select(0);
        nav.hidden = false;
      }
      select(selected) {
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('aria-selected', String(index === selected));
          tab.tabIndex = index === selected ? 0 : -1;
          this.panels[index].hidden = index !== selected;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pawprint-trust-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pawprint-shipping-countdown')) {
    class PawprintShippingCountdown extends HTMLElement {
      static easternFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', year: 'numeric', month: 'numeric',
        day: 'numeric', hour: 'numeric', hourCycle: 'h23'
      });

      static easternParts(timestamp) {
        return Object.fromEntries(this.easternFormatter.formatToParts(timestamp)
          .filter(part => part.type !== 'literal')
          .map(part => [part.type, Number(part.value)]));
      }

      static nextDispatch(now) {
        const local = this.easternParts(now);
        for (let days = 0; days < 8; days += 1) {
          const calendarDay = new Date(Date.UTC(local.year, local.month - 1, local.day + days));
          const weekday = calendarDay.getUTCDay();
          if (weekday === 0 || weekday === 6) continue;
          const anchor = calendarDay.getTime() + 15 * 3600000;
          const target = anchor + (10 - this.easternParts(anchor).hour) * 3600000;
          if (target > now) return target;
        }
        throw new Error('No upcoming weekday dispatch');
      }

      static formatRemaining(milliseconds) {
        const total = Math.max(0, Math.ceil(milliseconds / 1000));
        return [Math.floor(total / 3600), Math.floor(total / 60) % 60, total % 60]
          .map(value => String(value).padStart(2, '0')).join(':');
      }

      connectedCallback() {
        this.timer = this.querySelector('[role="timer"]');
        this.countdown = this.querySelector('[data-shipping-countdown]');
        this.fallback = this.querySelector('[data-shipping-fallback]');
        if (!this.timer || !this.countdown || !this.fallback) return;
        clearInterval(this.interval);
        this.update();
        this.interval = setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      update() {
        try {
          const now = Date.now();
          const target = PawprintShippingCountdown.nextDispatch(now);
          this.timer.textContent = PawprintShippingCountdown.formatRemaining(target - now);
          this.dataset.dispatchAt = new Date(target).toISOString();
          this.fallback.hidden = true;
          this.countdown.hidden = false;
        } catch {
          this.fallback.hidden = false;
          this.countdown.hidden = true;
        }
      }
    }
    customElements.define('pawprint-shipping-countdown', PawprintShippingCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ppl-species-navigation"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ppl-species-addons')){
  customElements.define('ppl-species-addons',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      const header=document.querySelector('[data-ppl-header]');
      const navigation=header?.querySelector('.navlinks');
      const oldShop=header?.querySelector('.shop-dropdown');
      const opener=header?.querySelector('.menu');
      if(!header||!navigation||!oldShop||!opener)return;
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.header=header;
      this.opener=opener;
      this.oldOpenerAttributes=Object.fromEntries(['aria-controls','aria-expanded','aria-label','aria-haspopup'].map(key=>[key,opener.getAttribute(key)]));
      const fragment=this.querySelector('template').content.cloneNode(true);
      const existingTabs=navigation.querySelector('.ppl-species-tabs');
      const tabs=existingTabs||fragment.querySelector('.ppl-species-tabs');
      const panels=[...fragment.querySelectorAll('[data-desktop-panel]')];
      const drawer=fragment.querySelector('.ppl-species-drawer');
      const main=drawer.querySelector('[data-mobile-main]');
      const mainTitle=drawer.getAttribute('aria-labelledby');
      const triggers=[...tabs.querySelectorAll('[data-desktop-trigger]')];
      this.nodes=[...(existingTabs?[]:[tabs]),...panels,drawer];
      this.drawer=drawer;
      if(!existingTabs)navigation.insertBefore(tabs,oldShop);
      header.append(...panels,drawer);
      header.classList.add('ppl-species-enhanced');
      const desktop=matchMedia('(min-width:801px)');
      const closeDesktop=()=>{clearTimeout(this.timer);this.active=null;triggers.forEach(a=>a.setAttribute('aria-expanded','false'));panels.forEach(p=>p.hidden=true);};
      const showDesktop=species=>{if(!desktop.matches)return;clearTimeout(this.timer);this.active=species;triggers.forEach(a=>a.setAttribute('aria-expanded',String(a.dataset.desktopTrigger===species)));panels.forEach(p=>p.hidden=p.dataset.desktopPanel!==species);};
      triggers.forEach(trigger=>{
        trigger.addEventListener('mouseenter',()=>showDesktop(trigger.dataset.desktopTrigger),{signal});
        trigger.addEventListener('focus',()=>showDesktop(trigger.dataset.desktopTrigger),{signal});
        trigger.addEventListener('keydown',event=>{if(['ArrowDown',' '].includes(event.key)){event.preventDefault();showDesktop(trigger.dataset.desktopTrigger);panels.find(p=>!p.hidden)?.querySelector('a')?.focus();}},{signal});
      });
      header.addEventListener('mouseenter',()=>clearTimeout(this.timer),{signal});
      header.addEventListener('mouseleave',()=>{this.timer=setTimeout(closeDesktop,300);},{signal});
      header.addEventListener('focusout',event=>{if(event.relatedTarget&&!header.contains(event.relatedTarget))closeDesktop();},{signal});
      document.addEventListener('pointerdown',event=>{if(!header.contains(event.target))closeDesktop();},{signal});
      header.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.active){const trigger=triggers.find(a=>a.dataset.desktopTrigger===this.active);closeDesktop();trigger?.focus({preventScroll:true});closeDesktop();}},{signal});
      const back=(restore=true)=>{
        const previous=drawer.dataset.view;
        delete drawer.dataset.view;
        drawer.setAttribute('aria-labelledby',mainTitle);
        main.inert=false;
        drawer.querySelectorAll('[data-mobile-panel]').forEach(p=>{p.hidden=true;p.inert=true;});
        if(restore&&previous)drawer.querySelector('[data-mobile-species="'+previous+'"]')?.focus();
      };
      opener.setAttribute('aria-controls',drawer.id);
      opener.setAttribute('aria-haspopup','dialog');
      opener.addEventListener('click',event=>{
        if(desktop.matches)return;
        event.preventDefault();event.stopImmediatePropagation();
        navigation.classList.remove('open');
        closeDesktop();back(false);
        this.previousOverflow=document.documentElement.style.overflow;
        document.documentElement.style.overflow='hidden';
        opener.setAttribute('aria-expanded','true');
        drawer.showModal();
      },{signal,capture:true});
      drawer.querySelector('[data-close-mobile]').addEventListener('click',()=>drawer.close(),{signal});
      drawer.querySelectorAll('[data-mobile-species]').forEach(button=>button.addEventListener('click',()=>{
        const species=button.dataset.mobileSpecies;
        drawer.dataset.view=species;main.inert=true;
        drawer.querySelectorAll('[data-mobile-panel]').forEach(p=>{const selected=p.dataset.mobilePanel===species;p.hidden=!selected;p.inert=!selected;});
        const panel=drawer.querySelector('[data-mobile-panel="'+species+'"]');
        drawer.setAttribute('aria-labelledby',panel.querySelector('h2').id);
        panel.querySelector('[data-mobile-back]')?.focus();
      },{signal}));
      drawer.querySelectorAll('[data-mobile-back]').forEach(button=>button.addEventListener('click',()=>back(),{signal}));
      drawer.addEventListener('close',()=>{document.documentElement.style.overflow=this.previousOverflow||'';back(false);opener.setAttribute('aria-expanded','false');opener.focus({preventScroll:true});},{signal});
      drawer.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>drawer.close(),{signal}));
      desktop.addEventListener('change',()=>{closeDesktop();if(desktop.matches&&drawer.open)drawer.close();},{signal});
      const applyPetTab=species=>{if(!['dog','cat'].includes(species))return;const tab=document.querySelector('#shop [role="tab"][id$="-'+species+'-tab"]');if(tab?.getAttribute('aria-selected')!=='true')tab?.click();};
      const applyLocation=()=>applyPetTab(new URLSearchParams(location.search).get('pet'));
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{applyLocation();setTimeout(applyLocation,250);},{once:true,signal});else applyLocation();
      header.addEventListener('click',event=>{
        const link=event.target.closest('a[href]');if(!link)return;
        const url=new URL(link.href,location.href);
        if(url.origin===location.origin&&url.pathname===location.pathname&&url.hash==='#shop'&&url.searchParams.has('pet')){
          event.preventDefault();closeDesktop();applyPetTab(url.searchParams.get('pet'));history.replaceState(null,'',url.pathname+url.search+url.hash);document.getElementById('shop')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        }
      },{signal});
    }
    disconnectedCallback(){
      if(this.drawer?.open){this.drawer.close();document.documentElement.style.overflow=this.previousOverflow||'';}
      this.controller?.abort();clearTimeout(this.timer);
      this.nodes?.forEach(node=>node.remove());
      this.header?.classList.remove('ppl-species-enhanced');
      if(this.opener&&this.oldOpenerAttributes)Object.entries(this.oldOpenerAttributes).forEach(([key,value])=>{if(value===null)this.opener.removeAttribute(key);else this.opener.setAttribute(key,value);});
      this.controller=null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pw-probiotic-serving-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pw-probiotic-serving-guide')){
  customElements.define('pw-probiotic-serving-guide',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      const tabs=[...this.querySelectorAll('[data-dose-tab]')];
      const select=tab=>{
        tabs.forEach(item=>{const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;});
        this.querySelectorAll('[data-dose-panel]').forEach(panel=>panel.hidden=panel.dataset.dosePanel!==tab.dataset.doseTab);
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>select(tab),options);
        tab.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight'||event.key==='ArrowLeft')next=(index+1)%tabs.length;
          else if(event.key==='Home')next=0;
          else if(event.key==='End')next=tabs.length-1;
          if(next===undefined)return;
          event.preventDefault();select(tabs[next]);tabs[next].focus();
        },options);
      });
    }
    disconnectedCallback(){this.controller?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pw-wellness-shared"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pw-wellness-content')){class PwWellnessContent extends HTMLElement{connectedCallback(){if(this.controller)return;this.controller=new AbortController();const options={signal:this.controller.signal};const track=this.querySelector('[data-pw-id="ingredient-carousel"]');if(track){const prev=this.querySelector('[data-pw-id="ingredient-prev"]'),next=this.querySelector('[data-pw-id="ingredient-next"]');const update=()=>{prev.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;};const slide=d=>{const card=track.querySelector('.ingredient-card');if(card)track.scrollBy({left:d*(card.offsetWidth+(parseFloat(getComputedStyle(track).columnGap)||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};prev.addEventListener('click',()=>slide(-1),options);next.addEventListener('click',()=>slide(1),options);track.addEventListener('scroll',update,{...options,passive:true});globalThis.addEventListener('resize',update,options);this.querySelectorAll('.ingredient-card').forEach(card=>card.addEventListener('click',()=>{const expanded=card.getAttribute('aria-expanded')==='true';this.querySelectorAll('.ingredient-card').forEach(c=>c.setAttribute('aria-expanded','false'));card.setAttribute('aria-expanded',String(!expanded));},options));update();}const dialog=this.querySelector('dialog');if(dialog)dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}},options);}disconnectedCallback(){this.controller?.abort();this.controller=null;}}customElements.define('pw-wellness-content',PwWellnessContent);document.addEventListener('click',event=>{const button=event.target.closest('.pawprint-wellness [data-pw-id]');if(!button)return;const id=button.dataset.pwId,dialog=document.querySelector('.pawprint-wellness [data-pw-id="ingredient-dialog"]');if(['purchase-ingredients','see-ingredients','quality-ingredients'].includes(id))dialog?.showModal();if(id==='close-ingredients')dialog?.close();});}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pwl-wellness-shared"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pw-wellness-content')){class PwWellnessContent extends HTMLElement{connectedCallback(){if(this.controller)return;this.controller=new AbortController();const options={signal:this.controller.signal};const track=this.querySelector('[data-pw-id="ingredient-carousel"]');if(track){const prev=this.querySelector('[data-pw-id="ingredient-prev"]'),next=this.querySelector('[data-pw-id="ingredient-next"]');const update=()=>{prev.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;};const slide=d=>{const card=track.querySelector('.ingredient-card');if(card)track.scrollBy({left:d*(card.offsetWidth+(parseFloat(getComputedStyle(track).columnGap)||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};prev.addEventListener('click',()=>slide(-1),options);next.addEventListener('click',()=>slide(1),options);track.addEventListener('scroll',update,{...options,passive:true});globalThis.addEventListener('resize',update,options);this.querySelectorAll('.ingredient-card').forEach(card=>card.addEventListener('click',()=>{const expanded=card.getAttribute('aria-expanded')==='true';this.querySelectorAll('.ingredient-card').forEach(c=>c.setAttribute('aria-expanded','false'));card.setAttribute('aria-expanded',String(!expanded));},options));update();}const dialog=this.querySelector('dialog');if(dialog)dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}},options);}disconnectedCallback(){this.controller?.abort();this.controller=null;}}customElements.define('pw-wellness-content',PwWellnessContent);document.addEventListener('click',event=>{const button=event.target.closest('.pawprint-wellness [data-pw-id]');if(!button)return;const id=button.dataset.pwId,dialog=document.querySelector('.pawprint-wellness [data-pw-id="ingredient-dialog"]');if(['purchase-ingredients','see-ingredients','quality-ingredients'].includes(id))dialog?.showModal();if(id==='close-ingredients')dialog?.close();});}
  } catch(e) { console.error(e); }
})();

})();
